import Vue from 'vue';
import Component from 'vue-class-component';
import { AUTH_POPUPS } from '@/auth/values/auth.values';
import EdLoginPopup from '../ed-login-popup/ed-login-popup.vue';
import EdForgotPasswordPopup from '../ed-forgot-password-popup/ed-forgot-password-popup.vue';

@Component({
  name: 'ed-auth-popup',
  components: {
    EdLoginPopup,
    EdForgotPasswordPopup
  }
})
class EdAuthPopup extends Vue {

  public comp: string = AUTH_POPUPS.LOGIN;

  public goToPopup(value: string) {
    this.comp = value;
  }

}

export default Vue.component('ed-auth-popup', EdAuthPopup);
